import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'gtapp-stacked-bar-chart',
  standalone: false,
  templateUrl: './stacked-bar-chart.component.html',
  styleUrl: './stacked-bar-chart.component.scss',
})
export class StackedBarChartComponent implements OnInit, OnChanges, OnDestroy {
  Math = Math;
  @Input() data: any = [];
  @Input() otherParams: any;
  paginatedChartData: any = [];

  @Output() segmentClick = new EventEmitter<any>();
  @Output() barClick = new EventEmitter<any>();
  @Output() paginationChange = new EventEmitter();

  legendItems: any[] = [];
  maxTotal = 0;
  minTotal = 0;

  totalRows: number = 0;
  previousRows: number = 0;
  rows: number = 30;
  pageNum: number = 1;
  totalPages: number = 0;

  apiFiltering: boolean = false;
  constructor() {}
  ngOnInit(): void {
    this.prepareChart();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.apiFiltering = Boolean(this.otherParams?.apiFiltering);
    if (this.otherParams?.paginationData?.rows >= 0) {
      this.totalRows = this.otherParams?.paginationData?.totalRows;
      this.previousRows = this.otherParams?.paginationData?.previousRows;
      this.rows = this.otherParams?.paginationData?.rows;
      this.pageNum = this.otherParams?.paginationData?.pageNum;
      this.totalPages = this.otherParams?.paginationData?.totalPages;
    }
    this.paginatedChartData = JSON.parse(JSON.stringify(this.data));

    if (this.otherParams?.paginationData && !this.apiFiltering) {
      this.totalRows = this.data?.length;
      this.totalPages = Math.ceil(this.totalRows / this.rows);
      this.paginatedChartData = this.data?.slice(0, this.rows);
    }
    this.prepareChart();
  }
  // ngOnChanges(changes: SimpleChanges): void {
  //
  // }
  ngOnDestroy(): void {}
  // getTotal(bar: any): number {
  //   return bar.segments.reduce((a: number, b: any) => a + b.value, 0);
  // }

  // get legend() {
  //   const map = new Map();
  //   this.data?.forEach((bar: any) => {
  //     bar?.segments?.forEach((seg: any) => {
  //       if (!map.has(seg.label)) map.set(seg.label, seg.color);
  //     });
  //   });
  //   return Array.from(map, ([label, color]) => ({ label, color }));
  // }
  onChangePagination(event: any) {
    this.previousRows = event.previous;
    this.pageNum = event.pageNum;
    this.rows = event.pageSize;
    if (this.apiFiltering) {
      this.paginationChange.emit({
        paginationData: {
          totalRows: this.totalRows,
          previousRows: this.previousRows,
          rows: this.rows,
          pageNum: this.pageNum,
          totalPages: this.totalPages,
        },
      });
    } else {
      this.paginatedChartData = this.data?.slice(
        this.previousRows,
        this.rows * this.pageNum,
      );
    }
  }
  prepareChart(): void {
    const totals: number[] = [];

    const legendMap = new Map();

    this.paginatedChartData = this.paginatedChartData?.map((item: any) => {
      const total = item.segments.reduce((sum: number, seg: any) => {
        if (!legendMap.has(seg.label)) {
          legendMap.set(seg.label, seg.color);
        }
        return sum + seg.value;
      }, 0);

      totals.push(total);

      return { ...item, total };
    });

    this.maxTotal = Math.max(...totals);
    this.minTotal = Math.min(...totals);
    this.maxTotal = this.maxTotal * 1.2;

    // Convert legend map to array
    this.legendItems = Array.from(legendMap, ([label, color]) => ({
      label,
      color,
    }));
  }
  getStackBarHeight(total: number): number {
    if (!this.maxTotal || this.maxTotal === 0) return 0;

    const range = this.maxTotal - this.minTotal || 1;
    const normalized = (total - this.minTotal) / range;

    const stretched = Math.pow(normalized, 0.7);

    const minHeight = 30;
    const maxHeight = 95;

    return minHeight + stretched * (maxHeight - minHeight);
  }
}
